import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/en',
    name: '',
    redirect: '/',
  },
  {
    path: '/About',
    name: 'about', 
    meta: {
      index: 3,
    },
    component: () => import('../views/About.vue')
  },
  {
    path: '/News',
    name: 'news', 
    meta: {
      index: 3,
    },
    component: () => import('../views/News.vue')
  },
  {
    path: '/NewsDetail',
    name: 'newsDetail', 
    meta: {
      index: 3,
    },
    component: () => import('../views/NewsDetail.vue')
  },
  {
    path: '/Contact',
    name: 'ContactPage', 
    meta: {
      index: 3,
    },
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/Wisdom_AI_Applications',
    name: 'wisdomAi',
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/wisdomAi.vue')
  },
  {
    path: '/Wisdom_BI_Analysis',
    name: 'wisdomAnalysis',
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/wisdomAnalysis.vue')
  },
  {
    path: '/Business_Manage_System',
    name: 'businessManage',
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/businessManage.vue')
  },
  {
    path: '/Intelligent_Device_Management_Platform',
    name: 'noah',
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/noah.vue')
  },
  {
    path: '/Automation',
    name: 'automation',
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/automation.vue')
  },
  {
    path: '/AI_Robot',
    name: 'aiRobot',
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/aiRobot.vue')
  },
  {
    path: '/Follow_Robot',
    name: 'followRobot',
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/followRobot.vue')
  },
  {
    path: '/Wearable_Devices',
    name: 'wearableDevices', 
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/wearableDevices.vue')
  },
  {
    path: '/Self_Collect_Devices',
    name: 'selfCollectDevices', 
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/selfCollectDevices.vue')
  },
  {
    path: '/High_Precision_Positioning_Devices',
    name: 'positioningDevices', 
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/positioningDevices.vue')
  },
  {
    path: '/Display_Updated_Devices',
    name: 'updateDevices', 
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/updateDevices.vue')
  },

  {
    path: '/Quick_Inventory_Scanning_Devices',
    name: 'scanDevices', 
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/scanDevices.vue')
  },
  {
    path: '/Lighting_Guidance_Devices',
    name: 'guidanceDevices', 
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/guidanceDevices.vue')
  },
  {
    path: '/Safety_Protection_Devices',
    name: 'safetyDevices', 
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/safetyDevices.vue')
  },
  // 无人值守设备
  {
    path: '/Unattended_Devices',
    name: 'unattendedDevices', 
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/unattendedDevices.vue')
  },
  {
    path: '/Tool_Circulation_Track_Devices',
    name: 'trackDevices', 
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/trackDevices.vue')
  },
  {
    path: '/Quick_Call_Devices',
    name: 'callDevices', 
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/callDevices.vue')
  },
  {
    path: '/Information_Perception_Devices',
    name: 'perceptionDevices', 
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/perceptionDevices.vue')
  },
  {
    path: '/Error_Proofing_Prompt_Devices',
    name: 'promptDevices', 
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/promptDevices.vue')
  },
  {
    path: '/Baggage_Identification_Devices',
    name: 'baggageIdentification', 
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/baggageIdentification.vue')
  },

  {
    path: '/Supply_Chain_Manage',
    name: 'supplyChain', 
    meta: {
      index: 1,
    },
    component: () => import('../views/Scenes/supplyChain.vue')
  },
  {
    path: '/Material_External_Warehouse_Manage',
    name: 'material', 
    meta: {
      index: 1,
    },
    component: () => import('../views/Scenes/material.vue')
  },
  {
    path: '/Park_Manage',
    name: 'park', 
    meta: {
      index: 1,
    },
    component: () => import('../views/Scenes/park.vue')
  },
  {
    path: '/Platform_Manage',
    name: 'platform', 
    meta: {
      index: 1,
    },
    component: () => import('../views/Scenes/platform.vue')
  },
  {
    path: '/Loading_and_Unloading_Vehicle_Storage',
    name: 'inStorage', 
    meta: {
      index: 1,
    },
    component: () => import('../views/Scenes/inStorage.vue')
  },
  {
    path: '/Finished_Product_Storage_and_Tallying',
    name: 'tally', 
    meta: {
      index: 1,
    },
    component: () => import('../views/Scenes/tally.vue')
  },
  {
    path: '/Order_Picking',
    name: 'picking', 
    meta: {
      index: 1,
    },
    component: () => import('../views/Scenes/picking.vue')
  },
  {
    path: '/Production_Process_Data_Manage',
    name: 'productionData', 
    meta: {
      index: 1,
    },
    component: () => import('../views/Scenes/productionData.vue')
  },
  {
    path: '/Finished_Product_External_Warehouse_Manage',
    name: 'externaWarehouse', 
    meta: {
      index: 1,
    },
    component: () => import('../views/Scenes/externaWarehouse.vue')
  },
  {
    path: '/Delivery_Transport',
    name: 'delivery', 
    meta: {
      index: 1,
    },
    component: () => import('../views/Scenes/delivery.vue')
  },

  {
    path: '/Operational_Standard_Manage',
    name: 'operationalStandard', 
    meta: {
      index: 1,
    },
    component: () => import('../views/Scenes/operationalStandard.vue')
  },
  {
    path: '/Device_Inspection_Maintenance_Manage',
    name: 'inspectionMaintenance', 
    meta: {
      index: 1,
    },
    component: () => import('../views/Scenes/inspectionMaintenance.vue')
  },
  {
    path: '/Property_Manage',
    name: 'property', 
    meta: {
      index: 1,
    },
    component: () => import('../views/Scenes/property.vue')
  },
  {
    path: '/Staff_Manage',
    name: 'staff', 
    meta: {
      index: 1,
    },
    component: () => import('../views/Scenes/staff.vue')
  },
  {
    path: '/Vehicle_Manage',
    name: 'vehicle', 
    meta: {
      index: 1,
    },
    component: () => import('../views/Scenes/vehicle.vue')
  },
  
  {
    path: '/Vehicle_Industry',
    name: 'vehicleIndustry', 
    meta: {
      index: 2,
    },
    component: () => import('../views/Industrys/vehicle.vue')
  },
  {
    path: '/Auto_Parts_Industry',
    name: 'vehicleAutoParts', 
    meta: {
      index: 2,
    },
    component: () => import('../views/Industrys/vehicleAutoParts.vue')
  },
  {
    path: '/Machinery_Industry',
    name: 'machineryIndustry', 
    meta: {
      index: 2,
    },
    component: () => import('../views/Industrys/machinery.vue')
  },
  {
    path: '/Home_Appliance_Industry',
    name: 'homeAppliance', 
    meta: {
      index: 2,
    },
    component: () => import('../views/Industrys/homeAppliance.vue')
  },
  {
    path: '/Manufacturing_Industry',
    name: 'manufacturing', 
    meta: {
      index: 2,
    },
    component: () => import('../views/Industrys/manufacturing.vue')
  },
  {
    path: '/Biomedical_Industry',
    name: 'biomedical', 
    meta: {
      index: 2,
    },
    component: () => import('../views/Industrys/biomedical.vue')
  },
  {
    path: '/Daily_Chemicals_Industry',
    name: 'dailyChemicals', 
    meta: {
      index: 2,
    },
    component: () => import('../views/Industrys/dailyChemicals.vue')
  },
  {
    path: '/Smelting_Industry',
    name: 'smelting', 
    meta: {
      index: 2,
    },
    component: () => import('../views/Industrys/smelting.vue')
  },
  {
    path: '/Electrical_Industry',
    name: 'electrical', 
    meta: {
      index: 2,
    },
    component: () => import('../views/Industrys/electrical.vue')
  },
  {
    path: '/Logistics_Industry',
    name: 'logistics', 
    meta: {
      index: 2,
    },
    component: () => import('../views/Industrys/logistics.vue')
  },
  {
    path: '/Chemical_Industry',
    name: 'chemical', 
    meta: {
      index: 2,
    },
    component: () => import('../views/Industrys/chemical.vue')
  },
  {
    path: '/High-speed_Train_Production_Industry',
    name: 'highspeedTrain', 
    meta: {
      index: 2,
    },
    component: () => import('../views/Industrys/highspeedTrain.vue')
  },
  {
    path: '/Spaceflight_Industry',
    name: 'spaceflight', 
    meta: {
      index: 2,
    },
    component: () => import('../views/Industrys/spaceflight.vue')
  },
  {
    path: '/Transport_Industry',
    name: 'transport', 
    meta: {
      index: 2,
    },
    component: () => import('../views/Industrys/transport.vue')
  },
  {
    path: '/Municipal_Public_Service_Industry',
    name: 'municipal', 
    meta: {
      index: 2,
    },
    component: () => import('../views/Industrys/municipal.vue')
  },
  {
    path: '/Medical_Service_Industry',
    name: 'medicalService', 
    meta: {
      index: 2,
    },
    component: () => import('../views/Industrys/medicalService.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


// 解决重复点击导航时，控制台出现报错
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router
